import { BackBar } from '../../components/BackBar'
import { EmbeddedDocFrame } from '../../components/EmbeddedDocFrame'
import { WebsiteHeader, WebsiteHeaderSpacer } from '../../components/WebsiteHeader'
import { useThemeColor } from '../../hooks/StatusBarColorPicker'

// NDA form URL — this is a public form
const NDA_URL =
  'https://innovateguyana.omnidek.com/public-form/d2ebd6c2-b1cf-40ba-b3d2-55a95089baec/EDA%20Non%20Disclosure%20Agreement'

export function NdaScreen() {
  useThemeColor('#FFFFFF') // match the website header

  return (
    <div className="flex min-h-dvh flex-col bg-gray-50">
      <WebsiteHeader />
      <main className="flex min-h-dvh flex-1 flex-col">
        <WebsiteHeaderSpacer />
        <div className="mx-auto flex w-full max-w-screen-sm flex-1 flex-col md:max-w-[1440px]">
          <BackBar label="Non disclosure agreement" to="/home" />
          <EmbeddedDocFrame
            title=""
            src={NDA_URL}
            fill="page"
            maskBottomBar
          />
        </div>
      </main>
    </div>
  )
}
